import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import rList from '../../../../api/models/rList';
import { rHaritadaAra } from '../../../../api/models/rHaritadaAra';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_HARITADAARA,
    new Api.Veri.HaritadaAra().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rHaritadaAra> | null | undefined,
  error: IError | null | undefined
): IApiAction<rHaritadaAra[]> =>
  ActionFunctions.action_async_complete_api<rHaritadaAra[]>(
    ActionSubTypes.API_HARITADAARA,
    data?.Values,
    error
  );
